import {RouteConfig} from "vue-router";
import localizationFactory from "@/router/modules/localization-factory";
import forex from '../../feature/Forex/router/forex';

export default Array<RouteConfig>(
	{
		path: "/",
		name: "Services",
		meta: localizationFactory('header.services', {
			layout: "main",
		}),
		component: () => import("../../views/Services/Services.vue")
	},
	{
		name: "CardIndex",
		path: "card-index",
		component: () => import("../../views/Services/CardIndex.vue"),
		meta: localizationFactory('cardIndex.header', {
			layout: "main",
			className: "header-sm-none"
		}),
	},
	{
		path: "sending-swift",
		component: () => import("../../views/Services/SendingSwiftLayout.vue"),
		meta: localizationFactory('sendingSwift.header', {
			layout: "main",
			className: "header-sm-none"
		}),
		children: [
			{
				name: "SendingSwiftContent",
				path: "/",
				component: () => import("../../views/Services/SendingSwift.vue"),
				meta: {
					className: "header-sm-none"
				},
			},
			{
				name: "SendingSwiftContentPath",
				path: ":path",
				component: () => import("../../views/Services/SendingSwift.vue"),
				meta: {
					className: "header-sm-none"
				},
				props: true,
			},
		]
	},
	{
		name: "Reports",
		path: "reports",
		component: () => import("../../views/Services/Reports.vue"),
		meta: localizationFactory('reports.header', {
			layout: "main",
			className: "header-sm-none"
		}),
	},
	{
		name: "ModuleLoan",
		path: "module-loan",
		component: () => import("../../views/Services/ModuleLoan.vue"),
		meta: localizationFactory('moduleCredit.header', {
			layout: "main",
			className: "header-sm-none",
			roles: [
				'DIRECTOR'
			]
		})
	},
	{
		name: "ECommerce",
		path: "e-commerce",
		component: () => import('../../views/Services/ECommerce.vue'),
		meta: localizationFactory('electCommerce.header', {
			layout: "main",
			className: "header-exchange-rates"
		}),
	},
	forex
);